import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '../../../../components/mui/Core/index'
import SiteMap from '../../../../components/SiteMap/site-map'

function SignUpOutlet() {
  const siteMapContainerStyle = { display: 'flex', justifyContent: 'center' }
  return (
    <>
      <Outlet />
      <Box sx={siteMapContainerStyle}>
        <SiteMap />
      </Box>
    </>
  )
}

export default SignUpOutlet
